module.exports = __webpack_public_path__ + "img/home_top2.e5374c1e.png";